export default __webpack_public_path__ + "static/media/plus_Icon.365352ec.svg";